import u from "lodash/get";
import c from "lodash/groupBy";
import s from "lodash/some";
function o(e) {
  return ["page", "feature", "poll", "guide"].includes(e.type);
}
function p(e) {
  return o(e) ? e.type : e.kind === "replay" ? "play-circle" : e.kind;
}
function g(e, n) {
  return e.filter((t) => n === "guideId" ? !(u(t, "attributes.resourceCenter") && t.state !== "public") : !0).map((t) => n === "guideId" ? {
    ...t,
    [n]: t.id,
    guideStepId: u(t, "steps[0].id")
  } : {
    [n]: t.id,
    name: t.name,
    group: {
      color: u(t.group, "color"),
      name: u(t.group, "name")
    }
  });
}
function m(e) {
  return {
    feature: [
      {
        fact: "eventCount",
        label: "Number of Clicks"
      },
      {
        fact: "daysActive",
        label: "Number of Days Active"
      }
    ],
    page: [
      {
        fact: "eventCount",
        label: "Number of Page Views"
      },
      {
        fact: "daysActive",
        label: "Number of Days Active"
      },
      {
        fact: "eventTime",
        label: "Time On Page (minutes)"
      }
    ],
    guide: [
      {
        fact: "guideViews",
        label: "Number of Guide Views"
      }
    ]
  }[e];
}
function y(e) {
  return e.map((n) => {
    const t = p(n);
    return {
      ...n,
      icon: {
        type: t,
        size: 14
      }
    };
  });
}
function b(e) {
  const n = {
    replay: "Replay Data",
    productUsage: "Product Usage",
    visitor: "Visitor Data",
    account: "Account Data",
    parentAccount: "Parent Account Data"
  }, t = c(e, (r) => o(r) ? "productUsage" : r.kind);
  return Object.keys(n).reduce((r, i) => {
    const a = t[i];
    return a && r.push({
      label: n[i],
      id: i,
      options: a
    }), r;
  }, []);
}
function v(e) {
  return s(e.steps, (n) => n.pollIds && n.pollIds.length);
}
export {
  y as getAvailableColumns,
  m as getFactOptionsForType,
  v as getHasPolls,
  p as getOptionIconType,
  g as getResourceOptions,
  b as groupOptionsByKind,
  o as isProductOption
};
//# sourceMappingURL=utils.js.map
